import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-add-filter-modal',
  templateUrl: './add-filter-modal.component.html',
  styleUrls: ['./add-filter-modal.component.scss']
})
export class AddFilterModalComponent implements OnInit {
  filterOptions = [];
  filters = [];

  constructor(
    public dialogRef: MatDialogRef<AddFilterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit(): void {
    this.filterOptions = this.data.filterOptions;
    this.filters = this.data.filters;
  }

  checkFilter(filter) {
    const exists = this.filters.find(f =>  f.tableName === filter.tableName);
    if (exists) {
      return true;
    }
    return false;
  }

  addFilter(filter) {
    if (this.checkFilter(filter)) {
      return false;
    }
    this.dialogRef.close(filter);
  }

}
